import React, {
    Component,
    useState
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import moment from 'moment';

import Icon from '@material-ui/core/Icon';

import { actionTypes } from '~/constants';
import awsconfig from '~/awsconfig';
import fetch from '~/utils/fetch';

import ChipDetails from '~/widgets/chip-details';
import LinkButton from '~/widgets/button-link'
import XInput from '~/widgets/x-input';
import XDate from '~/widgets/x-date';
import XSwitch from '~/widgets/x-switch';


class Container extends Component {
    constructor() {
        super()
        this.state = {
            error: null,
        }
    }

    async componentDidMount() {
        if(this.props.departments.list.length === 0){
            this.props.dispatch({type: actionTypes.DEPARTMENTS_FETCH_ALL})
        }
        this.props.dispatch({type: actionTypes.USERS_FETCH_ONE, id: this.props.match.params.user_id})
    }


    render() {
        console.log(this.props);
        // console.log(this.state);

        if(!this.props.users.is_loaded || !this.props.users.detail){
            return 'Loading...'  // hide while loading
        }

        const user = this.props.users.detail;

        const department = this.props.departments.list.find(d=>d._id===user.clientId) || {};

        const absenceLogs = (user.absenceLogs || []).map(log => ({
            startedAt: moment(log.startedAt).format('L'),
            endedAt: log.endedAt ? moment(log.endedAt).format('L') : 'now'
        })).map((log, index)=>(
            <div style={{color: '#737373', fontSize: '0.85rem', margin: '0.5rem 0'}}>
                Absence #{index+1}: {log.startedAt} - {log.endedAt}
            </div>
        ))

        return (
            <React.Fragment> {/* parent is div.page */}
                <div className="page-nav">
                    <div className="breadcrumb">
                        <LinkButton to={`/app/departments/${this.props.match.params.department_id || ''}`} className="button button-clear">
                            <Icon>arrow_back</Icon>&nbsp;&nbsp;Return To Department
                        </LinkButton>
                    </div>
                    <div className="page-actions">
                        {!this.props.users.detail.onboarded ? (
                            <LinkButton
                                className={`button button-wide button-secondary`}
                                onClick={async e=>{
                                    try {
                                        this.props.dispatch({type: actionTypes.SPINNING_START});
                                        let response = await fetch({
                                            url: `${awsconfig.officeApi}/users/${this.props.users.detail._id}/resend-new-account-email`,
                                            data: {},
                                            method: 'post',
                                        })
                                        console.log(response);
                                        this.props.dispatch({
                                            type: actionTypes.SNACKBAR,
                                            snackbar: {
                                                severity: 'success',
                                                text: `Sent the New Account email to ${this.props.users.detail.email}.`
                                            }
                                        });
                                    } catch (e) {
                                        console.error(e)
                                        this.props.dispatch({
                                            type: actionTypes.SNACKBAR,
                                            snackbar: {
                                                severity: 'error',
                                                text: e.message
                                            }
                                        });
                                    } finally {
                                        this.props.dispatch({type: actionTypes.SPINNING_STOP})
                                    }
                                }}
                            >
                                Send New Account Email
                            </LinkButton>
                        ) : (
                            <LinkButton
                                className={`button button-wide ${(this.props.users.detail.active ? 'button-red' : 'button-secondary')}`}
                                onClick={e=>{
                                    this.props.dispatch({
                                        type: actionTypes.USERS_UPDATE_ONE,
                                        id: this.props.users.detail._id,
                                        data: {...this.props.users.detail, active: !this.props.users.detail.active}
                                    })
                                }}
                            >
                                {(this.props.users.detail.active ? 'Deactivate' : 'Activate')} User
                            </LinkButton>
                        )}
                        <LinkButton to={`/app/departments/${this.props.match.params.department_id}/users/${this.props.match.params.user_id}/edit`} className="button button-gray button-wide">
                            Edit User
                        </LinkButton>
                    </div>
                </div>
                <div className="card">
                    {user.onboarded ? '' : (
                        <div className="card-stripes-yellow-black">
                            <div className="info-panel">
                                <div className="info-icon">
                                </div>
                                <div className="info-message">
                                    This user has <strong>not</strong> completed onboarding.
                                    {user.onboardingEmailSent ? null : 'An admin has not yet sent a New Account email to the user.'}
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="card-content">
                        <h2>
                            {user.firstname}
                            &nbsp;
                            {user.lastname}
                        </h2>
                        <br/>
                        <div className="chip-details">
                            <ChipDetails
                                link={`https://citadel.virtualclaimsadjuster.com/contacts/rep/viewRep.asp?PID=${user.vcaInternalRep}`}
                                label={`VCA #${user.vcaInternalRep || 'PENDING'}`}
                                status={!user.active ? 'error' : 'success'}
                            />
                        </div>
                    </div>
                    <div className="card-section">
                        Account Information
                    </div>
                    <div className="card-content">
                        <div className="details-row">
                            <div className="details-item">
                                <div className="details-item-label">
                                    Department
                                </div>
                                <div className="details-item-value">
                                    {department.name}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-section">
                        Personal Information
                    </div>
                    <div className="card-content">
                            <div className="details-item">
                                <div className="details-item-label">
                                    Badge #
                                </div>
                                <div className="details-item-value">
                                    {user.badgeNumber}
                                </div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    Email
                                </div>
                                <div className="details-item-value">
                                    {user.email}
                                </div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    Phone #
                                </div>
                                <div className="details-item-value">
                                    {user.phone}
                                </div>
                            </div>
                            {!user.mobile ? null : (
                                <div className="details-item">
                                    <div className="details-item-label">
                                        Mobile Phone #
                                    </div>
                                    <div className="details-item-value">
                                        {user.mobile}
                                    </div>
                                </div>
                            )}
                            <div className="details-item">
                                <div className="details-item-label">
                                    Role
                                </div>
                                <div className="details-item-value">
                                    {user.role}
                                </div>
                            </div>
                            <div className="details-item">
                                <div className="details-item-label">
                                    Auto-send Reports to VCA
                                </div>
                                <div className="details-item-value">
                                    {user.autoSendReportsVCA === true ? (
                                        <span><strong>Yes.</strong> Reports with accident numbers will go straight to VCA.</span>
                                    ) : (
                                        <span><strong>No.</strong> Reports will need to be submitted by eXmarX staff manually.</span>
                                    )}
                                </div>
                            </div>
                    </div>
                    {absenceLogs.length ? (
                        <React.Fragment>
                            <div className="card-section">
                                Absence Logs
                            </div>
                            <div className="card-content">
                                {absenceLogs}
                            </div>
                        </React.Fragment>
                    ) : null}
                </div>
            </React.Fragment>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            users: state.users,
            departments: state.departments
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(Container);